import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addJournalEntry = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_journal_entry',
    '/api/resource/Journal Entry',
    body
  );
  return data;
});

export const updateJournalEntry = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    // '/api/method/technoerp.services.update_journal_entry',
    `/api/resource/Journal Entry/${id}`,
    body
  );
  return data;
});
export const manageJournalEntry = catchAsync(async ({ action, name }) => {
  console.log(name, 'name');
  const { data } = await axiosInstance.delete(
    // `/api/method/technoerp.services.manage_journal_entry?name=ACC-JV-2024-00013&action=submit,cancel,delete`
    `/api/method/technoerp.services.manage_journal_entry?name=${name}&action=${action}`
  );
  return data;
});

export const getJournalEntries = catchAsync(
  async (searchKey, searchText, currentLang) => {
    let baseUrl = `/api/resource/Journal Entry?fields=["name", "title", "voucher_type", "total_debit","total_credit", "cheque_no", "docstatus"]&_lang=${currentLang}&limit_start=0&limit_page_length=0&order_by=name desc`;
    if (searchText) {
      baseUrl += `&filters=[["${searchKey}","like","%${searchText}%"]]`;
    }
    const { data } = await axiosInstance.get(
      baseUrl
      // '/api/method/technoerp.services.get_journal_entries'
      // `/api/resource/Journal Entry?fields=["name", "title", "voucher_type", "total_debit", "cheque_no", "docstatus"]&_lang=${currentLang}&limit_start=0&limit_page_length=0`
    );
    return data;
  }
);
export const getParties = catchAsync(async (partyType) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_parties?partyType=${partyType}`
  );
  return data;
});
export const getJournalEntryDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.get_journal_entry?name=${id}`
    `/api/resource/Journal Entry/${id}`
  );
  return data;
});
